import { LinkedAnalogues } from '~/components/wiki/lithostrat/LinkedAnalogues';
import { useMemberDetailOutletContext } from '~/routes/wiki/regional/lithostrat/member.$memberId';

export default function MemberExamplesRoute() {
  const { member } = useMemberDetailOutletContext();
  return <LinkedAnalogues analogues={member.outcropLinkAnalogues} />;
}
